import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import VirtualAssistantProvider from './VirtualAssistantProvider';
import RingOverlay from './RingOverlay';
import ActiveRingersBar from './ActiveRingersBar';

export default function AppShell() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { pathname } = useLocation();
  // The dedicated /chat route hides all chrome on phones. The Messenger page
  // keeps its top bar (navigation) but owns the remaining viewport height —
  // no page padding and no bottom avatar reserve (owner report 2026-10-21).
  const isChat = pathname === '/chat';
  const isMessenger = pathname.startsWith('/app/messenger');

  return (
    <VirtualAssistantProvider>
      <div className="flex h-[100dvh] min-h-0 flex-col overflow-hidden app-canvas">
        {/* Green "N active ringer(s)" bar — renders nothing unless an agent is
            ringing (owner directive 2026-10-10). */}
        <ActiveRingersBar />
        <div className="flex min-h-0 flex-1 overflow-hidden">
          <a href="#main-content" className="skip-link">
            Skip to content
          </a>
          <div className={`${isChat ? 'hidden lg:block' : ''} lg:h-full lg:min-h-0`}>
            <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
          </div>
          <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
            <div className={isChat ? 'hidden lg:block' : ''}>
              <TopBar onMenuClick={() => setSidebarOpen(true)} />
            </div>
            {/* Reserve a strip at the bottom (and the avatar's column on the
                right, desktop) so the draggable assistant avatar never covers a
                card's text — on phones AND on desktop, at any scroll position.
                Targeted to this one element (no global rule). */}
            <main
              id="main-content"
              className={isChat || isMessenger ? 'min-h-0 flex-1 overflow-hidden p-0' : 'min-h-0 flex-1 overflow-y-auto overflow-x-clip p-4 pb-32 lg:p-6 lg:pb-40 lg:pr-28'}
              tabIndex={-1}
            >
              <Outlet />
            </main>
          </div>
        </div>
      </div>
      {/* Global "the assistant is ringing you" overlay (owner directive 2026-09-30). */}
      <RingOverlay />
    </VirtualAssistantProvider>
  );
}
